<ul class="rates" [class.rates--dark]="variant === 'dark'">
  <li class="rate" *ngFor="let code of codes">
    <span class="rate__flag" aria-hidden="true" [ngSwitch]="code">
      <svg *ngSwitchCase="'USD'" viewBox="0 0 24 24" width="16" height="16">
        <defs><clipPath [attr.id]="'flag-us-' + variant"><circle cx="12" cy="12" r="12"/></clipPath></defs>
        <g [attr.clip-path]="'url(#flag-us-' + variant + ')'">
          <rect width="24" height="24" fill="#fff"/>
          <rect y="0" width="24" height="3.4" fill="#d22f3c"/>
          <rect y="6.9" width="24" height="3.4" fill="#d22f3c"/>
          <rect y="13.7" width="24" height="3.4" fill="#d22f3c"/>
          <rect y="20.6" width="24" height="3.4" fill="#d22f3c"/>
          <rect width="13" height="13.7" fill="#3c3b6e"/>
        </g>
      </svg>
      <svg *ngSwitchCase="'EUR'" viewBox="0 0 24 24" width="16" height="16">
        <circle cx="12" cy="12" r="12" fill="#1f4aa8"/>
        <g fill="#ffcc00">
          <circle cx="12" cy="5" r="1.1"/><circle cx="15.5" cy="5.9" r="1.1"/><circle cx="18.1" cy="8.5" r="1.1"/>
          <circle cx="19" cy="12" r="1.1"/><circle cx="18.1" cy="15.5" r="1.1"/><circle cx="15.5" cy="18.1" r="1.1"/>
          <circle cx="12" cy="19" r="1.1"/><circle cx="8.5" cy="18.1" r="1.1"/><circle cx="5.9" cy="15.5" r="1.1"/>
          <circle cx="5" cy="12" r="1.1"/><circle cx="5.9" cy="8.5" r="1.1"/><circle cx="8.5" cy="5.9" r="1.1"/>
        </g>
      </svg>
      <svg *ngSwitchCase="'CNY'" viewBox="0 0 24 24" width="16" height="16">
        <circle cx="12" cy="12" r="12" fill="#de2910"/>
        <path fill="#ffde00" d="M7 4.2l1.1 3.3h3.4L8.8 9.6l1 3.2L7 10.8l-2.8 2 1-3.2L2.5 7.5h3.4z"/>
      </svg>
    </span>
    <span class="rate__code">{{ code }}</span>
    <span class="rate__value">{{ rates[code] | number:'1.2-2' }}</span>
  </li>
</ul>
